/** Strings of the project tabs: members, files, planner, suggestions and keys. */
export const projTabsEn = {
  projMembers: {
    title: "Members",
    count_one: "{{count}} member",
    count_other: "{{count}} members",
    count_few: "{{count}} members",
    roles: {
      manager: "Manager",
      developer: "Developer",
      tester: "Tester",
      maintainer: "Maintainer",
      client: "Client",
    },
    access: {
      none: "No repo access",
      guest: "Guest",
      planner: "Planner",
      reporter: "Reporter",
      developer: "Developer",
      maintainer: "Maintainer",
      owner: "Owner",
    },
    error: "Error",
    addFailed: "Couldn't add the member",
    changeFailed: "Couldn't change the member",
    removeFailed: "Couldn't remove the member",
    name: "Name",
    email: "Email",
    rolesHeader: "Roles",
    gitlabAccess: "GitLab access",
    joined: "Joined",
    fixed: "Fixed",
    remove: "Remove",
    removeDialog: {
      title: "Remove from the team",
      description: "{{name}} will no longer be a member of this project in Hub.",
      alsoGitlab: "Also remove from the GitLab project",
      hint: "By default the person stays in GitLab and keeps access to the repository.",
      cancel: "Cancel",
      confirm: "Remove from the team",
    },
    addTitle: "Add Member",
    user: "User",
    selectUser: "Select a user...",
    noMoreUsers: "No more users to add",
    addButton: "Add Member",
    empty: "No members yet.",
  },
  projFiles: {
    title: "Files",
    linkLoading: "Opening the file…",
    linkForbidden: "You don't have access to this file.",
    linkMissing: "The file is no longer in Seafile (deleted or moved).",
    linkNoFiles: "This project has no files.",
    linkFailed: "Couldn't open the file link.",
    openInSeafile: "Open in Seafile",
    loading: "Loading…",
    empty: "This folder is empty.",
    someFolders: "some folders",
    shareFailed: "Couldn't change sharing",
    allMembers: "All members",
    sharedHint: "Every project member has this folder. Click to stop.",
    shareHint: "Share this folder with every project member, now and later",
    sharedWithAll: "Shared with all members",
    shareWithAll: "Share with all members",
  },
  projPlanner: {
    title: "Planner",
    intro:
      "Plan {{name}} with Radim: ideas, new and reworked tickets, plans for Metoděj, or a walk through the open tickets. Just tell him what you want.",
  },
  projSuggestions: {
    title: "Suggestions",
    intro:
      "What Hubert proposes about {{name}} — from meetings, forwarded client emails, WhatsApp and Discord. Approving one applies it through the normal flow, under your name; rejecting drops it.",
    emptyPending:
      "Nothing waiting for this project — proposals from meetings, emails and chats land here.",
  },
  projKeys: {
    copied: "{{label}} copied",
    copyFailed: "Couldn't copy the {{label}}",
    intro: "Items from the project's Vault collections. Every reveal is recorded.",
    search: "Search keys",
    loading: "Loading…",
    noMatch: "Nothing matches.",
    empty: "No items in this project's Vault collections.",
    revealFailed: "Couldn't reveal it",
    copyUsername: "Copy the username",
    username: "Username",
    revealItem: "Reveal {{name}}",
    hideItem: "Hide {{name}}",
    hide: "Hide",
    revealing: "Revealing…",
    reveal: "Reveal",
    password: "Password",
    notes: "Notes",
    copyLabel: "Copy {{label}}",
    copy: "Copy",
  },
};

export const projTabsCs: typeof projTabsEn = {
  projMembers: {
    title: "Členové",
    count_one: "{{count}} člen",
    count_other: "členů: {{count}}",
    count_few: "{{count}} členové",
    roles: {
      manager: "Manažer",
      developer: "Vývojář",
      tester: "Tester",
      maintainer: "Maintainer",
      client: "Klient",
    },
    access: {
      none: "Bez přístupu k repozitáři",
      guest: "Host",
      planner: "Plánovač",
      reporter: "Reportér",
      developer: "Vývojář",
      maintainer: "Maintainer",
      owner: "Vlastník",
    },
    error: "Chyba",
    addFailed: "Člena se nepodařilo přidat",
    changeFailed: "Člena se nepodařilo změnit",
    removeFailed: "Člena se nepodařilo odebrat",
    name: "Jméno",
    email: "E-mail",
    rolesHeader: "Role",
    gitlabAccess: "Přístup do GitLabu",
    joined: "Přidán",
    fixed: "Pevný",
    remove: "Odebrat",
    removeDialog: {
      title: "Odebrat z týmu",
      description: "{{name}} přestane být členem tohoto projektu v Hubu.",
      alsoGitlab: "Odebrat i z GitLab projektu",
      hint: "Ve výchozím stavu člověk zůstane v GitLabu a ponechá si přístup do repozitáře.",
      cancel: "Zrušit",
      confirm: "Odebrat z týmu",
    },
    addTitle: "Přidat člena",
    user: "Uživatel",
    selectUser: "Vyberte uživatele...",
    noMoreUsers: "Žádní další uživatelé k přidání",
    addButton: "Přidat člena",
    empty: "Zatím žádní členové.",
  },
  projFiles: {
    title: "Soubory",
    linkLoading: "Otevírám soubor…",
    linkForbidden: "K tomuto souboru nemáš přístup.",
    linkMissing: "Soubor už v Seafile není (smazaný nebo přesunutý).",
    linkNoFiles: "Tento projekt nemá soubory.",
    linkFailed: "Odkaz na soubor se nepodařilo otevřít.",
    openInSeafile: "Otevřít v Seafile",
    loading: "Načítání…",
    empty: "Tato složka je prázdná.",
    someFolders: "některé složky",
    shareFailed: "Sdílení se nepodařilo změnit",
    allMembers: "Všichni členové",
    sharedHint: "Tuto složku mají všichni členové projektu. Kliknutím sdílení zrušíte.",
    shareHint: "Sdílet tuto složku se všemi členy projektu, teď i do budoucna",
    sharedWithAll: "Sdíleno se všemi členy",
    shareWithAll: "Sdílet se všemi členy",
  },
  projPlanner: {
    title: "Plánovač",
    intro:
      "Naplánujte projekt {{name}} s Radimem: nápady, nové i přepracované tikety, plány pro Metoděje nebo společný průchod otevřenými tikety. Stačí mu říct, co chcete.",
  },
  projSuggestions: {
    title: "Návrhy",
    intro:
      "Co Hubert navrhuje k projektu {{name}} — ze schůzek, přeposlaných e-mailů od klientů, WhatsAppu a Discordu. Schválením se návrh provede běžným postupem pod vaším jménem, zamítnutím se zahodí.",
    emptyPending:
      "Pro tento projekt nic nečeká — návrhy ze schůzek, e-mailů a chatů přistanou tady.",
  },
  projKeys: {
    copied: "{{label}} zkopírováno",
    copyFailed: "Nepodařilo se zkopírovat: {{label}}",
    intro: "Položky z kolekcí projektu ve Vaultu. Každé odhalení se zaznamenává.",
    search: "Hledat klíče",
    loading: "Načítání…",
    noMatch: "Nic nevyhovuje.",
    empty: "V kolekcích tohoto projektu ve Vaultu nejsou žádné položky.",
    revealFailed: "Odhalení se nepodařilo",
    copyUsername: "Zkopírovat uživatelské jméno",
    username: "Uživatelské jméno",
    revealItem: "Odhalit {{name}}",
    hideItem: "Skrýt {{name}}",
    hide: "Skrýt",
    revealing: "Odhaluji…",
    reveal: "Odhalit",
    password: "Heslo",
    notes: "Poznámky",
    copyLabel: "Zkopírovat: {{label}}",
    copy: "Kopírovat",
  },
};
